var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsShowDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6925 2.69246C11.1025 2.28241 11.1025 1.61759 10.6925 1.20754C10.2824 0.797487 9.61759 0.797487 9.20754 1.20754L5.95 4.46508L2.69246 1.20754C2.28241 0.797487 1.61759 0.797487 1.20754 1.20754C0.797487 1.61759 0.797487 2.28241 1.20754 2.69246L5.20754 6.69246C5.61759 7.10251 6.28241 7.10251 6.69246 6.69246L10.6925 2.69246Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsShowDetail);
export default __webpack_public_path__ + "static/media/news_show_detail.2c37935b346549136951e09a2499a669.svg";
export { ForwardRef as ReactComponent };